import { getClientIdResponse } from './clientIdManager';
import createElementId from './createElementId';

import { TICK_MAX } from './uidConstants';

export default class ClientIdInstance {
    constructor() {
        this.refreshClientId();
    }

    refreshClientId() {
        const initId = getClientIdResponse();
        this.clientId = initId.clientId;
        this.clientTick = initId.clientTick;
    }

    getClientId() {
        return this.clientId;
    }

    getTick() {
        this.clientTick = this.clientTick + 1;

        if (this.clientTick >= TICK_MAX) {
            this.refreshClientId();
        }

        return this.clientTick;
    }

    getElementId() {
        const clientTick = this.getTick();
        const clientId = this.getClientId();

        return createElementId(clientId, clientTick);
    }
}

let globalInstance;
export const getGlobalClientId = () => {
    if (!globalInstance) globalInstance = new ClientIdInstance();
    return globalInstance;
};

/**
 * Re-reads the client id after the manager has been given a new offset.
 *
 * The instance caches the id it was built with, so without this a re-initialised server keeps
 * minting ids from the previous offset. Refreshed in place rather than discarded, so anything
 * already holding the instance sees the new id too.
 */
export const refreshGlobalClientId = () => {
    if (!globalInstance) return;

    globalInstance.refreshClientId();
};
